import {View} from 'react-native'
import {type ModerationDecision} from '@bsky/sdk/moderation'

import {sanitizeDisplayName} from '#/lib/strings/display-names'
import {sanitizeHandle} from '#/lib/strings/handles'
import {type Shadow} from '#/state/cache/types'
import {atoms as a, useBreakpoints, useTheme} from '#/alf'
import {ProfileBadges} from '#/components/ProfileBadges'
import {Text} from '#/components/Typography'
import {useNameStyle} from '#/features/avatarDecorations'
import {type app} from '#/lexicons'

export function ProfileHeaderDisplayName({
  profile,
  moderation,
}: {
  profile: Shadow<app.bsky.actor.defs.ProfileViewDetailed>
  moderation: ModerationDecision
}) {
  const t = useTheme()
  const {gtMobile} = useBreakpoints()
  const nameStyle = useNameStyle(profile.did)

  return (
    <View>
      <Text
        emoji
        testID="profileHeaderDisplayName"
        style={[
          t.atoms.text,
          gtMobile ? a.text_4xl : a.text_3xl,
          a.self_start,
          a.font_bold,
          a.leading_tight,
          nameStyle,
        ]}>
        {sanitizeDisplayName(
          profile.displayName || sanitizeHandle(profile.handle),
          moderation.ui('displayName'),
        )}
        <ProfileBadges
          profile={profile}
          size="lg"
          interactive
          inline
          style={[a.pl_xs]}
        />
        {/*
         * TODO: Workaround for a rounding bug in Android RN.
         * Fixed upstream in RN main (facebook/react-native#56651); remove this
         *  once we are on a release that contains it (0.86.0 should be good).
         */}{' '}
      </Text>
    </View>
  )
}
